import axios from 'axios';
import { getDomainOrSubdomain } from '../helpers/Util';

export const getClientSettings = async () => {
  const route = getDomainOrSubdomain();

  try {
    const url = `${process.env.REACT_APP_API_CONFIG_BASE_URL}/settings/client`;
    const payload = { route };
    const response = await axios.post(url, payload);
    const settings = response.data;

    return settings;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateSettings = async ({ headers, payload, id }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_CONFIG_BASE_URL}/settings/${id}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      if (err.response.data.duplicated) {
        throw new Error('duplicated');
      } else {
        throw new Error(err.response.data.message);
      }
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateSettingsRoute = async ({ headers, payload, id }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_CONFIG_BASE_URL}/settings/${id}/route`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      if (err.response.data.duplicated) {
        throw new Error('duplicated');
      } else {
        throw new Error(err.response.data.message);
      }
    } else {
      throw new Error(err.message);
    }
  }
};
